import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    CREATE_OPPORTUNITY,
    FILTER_CONTENT,
    GET_OPPORTUNITY_BY_ID,
    OPPORTUNITY_LIST,
    OPPORTUNITY_QUESTION, PROPOSAL_COMMERCIAL_CLOSURE,
    UPDATE_OPPORTUNITY
} from "./type";

/**
 *
 * @returns {(function(*): Promise<boolean|undefined>)|*}
 */
export const save = (requestParams) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestParams,
        `${Config.saveOpportunity}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: CREATE_OPPORTUNITY,
            payload: data.response,
        });
        return true;
    }
};

export const list = (accountId, page=1,  filterData = [{}], leadId = -1) => async (dispatch) => {
    let urls = `${Config.opportunityList}?page=${page}&account_id=${accountId}&lead_id=${leadId}`

    Object.keys(filterData[0]).map((val, i)=>{
        urls+="&"+val+"="+filterData[0][val]
    })
    const res = await callWebService(
        callTypes.get,
        '',
        urls
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: OPPORTUNITY_LIST,
            payload: data.response.data,
        });
        return true;
    }
};

export const opportunityQuestion = (type) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.opportunityQuestion}?id=${type}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: OPPORTUNITY_QUESTION,
            payload: data.response.data,
        });
        return true;
    }
};

export const getOpportunity = (id,accountId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getOpportunity}?id=${id}&account_id=${accountId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_OPPORTUNITY_BY_ID,
            payload: data.response.data,
        });
        return true;
    }
};

export const updateOpportunity = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.updateOpportunity}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: UPDATE_OPPORTUNITY,
            payload: data.response,
        });
        return true;
    }
};

export const getOpportunityFilter = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.opportunityFilterContent}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: FILTER_CONTENT,
            payload: data.response,
        });
        return true;
    }
};

export const proposalCommercialClosure = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.ProposalCommercialClosure}?id=${id}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: PROPOSAL_COMMERCIAL_CLOSURE,
            payload: data.response,
        });
        return true;
    }
};

export const saveForBA = (requestParams) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestParams,
        `${Config.baOpportunity}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: CREATE_OPPORTUNITY,
            payload: data.response,
        });
        return true;
    }
};

